module.exports = __webpack_public_path__ + "static/media/Tovi Grossman.2483893d.png";